export function ZendeskVehicleSync({
  make,
  model,
  year,
}: any) {
  window.fcWidget?.user?.setProperties({
    make,
    model,
    year,
  });

  // gtag("event", "vehicle_selected", {
  //   send_to: GTAG_ID,
  //   id: `${make}|${model}|${year}`.toLowerCase(), // 'ford|f150|2010',
  //   item_title: capitalize(`${make} ${model} ${year}`),
  //   make,
  //   model,
  //   year,
  //   google_business_vertical: "custom",
  // });
}
